import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";

export default function CustomDialog(props: any) {

    return <Dialog {...props} title={"Appointment"} />;
};
